import DesktopNavBar from "./DesktopNavBar";
import MobileNavBar from "./MobileNavbar";
import { AdminNavProvider } from "./NavContext";
import {
    BadgeDollarSign,
    CreditCard,
    Home,
    ShoppingCart,
    Users,
    Settings,
    UserCog,
    Package,
    List,
    DollarSign,
    Wallet,
} from 'lucide-react';

export interface NavItem {
    name: string;
    href: string;
    icon: React.ElementType;
    mode?: "dev";
    roles?: string[];
}

// Define all possible navigation items with role restrictions
const allNavItems: NavItem[] = [
    { name: 'Rewards Claims', href: '/rewards-claims', icon: BadgeDollarSign },
    { name: 'Payouts', href: '/payouts', icon: Wallet },
    { name: 'Users', href: '/users', icon: UserCog },
    { name: 'Benchmark Prices', href: '/benchmark-prices', icon: DollarSign },
];

export default function AdminNavbar() {
    return (
        <AdminNavProvider>
            <DesktopNavBar navItems={allNavItems} />
            <MobileNavBar navItems={allNavItems} />
        </AdminNavProvider>
    );
}
